/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const PASSWORD_POLICIES = 'Password Policies ';
export const PASSWORD_POLICIES_SUB = 'Password Policies are exclusively for users in Blue Yonder User Store';
export const ADD_POLICY = 'Add Policy';
export const SEARCH_PASSWORD_POLICIES = 'Search password policies';
export const SAVE = 'Save';
export const CANCEL = 'Cancel';
export const ADD = 'Add';
export const EDIT = 'Edit';
export const POLICY_NAME = 'Policy Name';
export const POLICY_DESCRIPTION = 'Policy Description';
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const RESET_TO_DEFAULT = 'Reset To Default';
export const SAVED_MESSAGE_SUCCESS = 'Password Policy saved successfully';
export const SAVED_MESSAGE_ERROR = 'Error while saving Password Policy';
const defaultFieldPasswordPolicy = { value: '', error: false, errorHelperText: '' };
export const formValuesPasswordPolicyDefault = {
    policyName: defaultFieldPasswordPolicy,
    minLength: defaultFieldPasswordPolicy,
    maxLength: defaultFieldPasswordPolicy,
    expiryDuration: defaultFieldPasswordPolicy,
    passwordHistoryEnabled: true,
    oldPasswords: defaultFieldPasswordPolicy,
    maxConsecutiveLetters: { ...defaultFieldPasswordPolicy, value: 'Unlimited' },
    includeNumbers: false,
    includeSpecialCharacters: false,
    lettersInMixedCase: false,
    excludeCommonUnsafePassword: false,
    excludeUserProfileInformation: false
};

export const maxConsecutiveLettersOptions = [
    { key: '0', displayName: 'Unlimited', value: 'Unlimited' },
    { key: '1', displayName: '1', value: '1' },
    { key: '2', displayName: '2', value: '2' },
    { key: '3', displayName: '3', value: '3' },
    { key: '4', displayName: '4', value: '4' },
    { key: '5', displayName: '5', value: '5' }
]

export const FORM_FIELDS = {
    policyName: 'name',
    minLength: 'minLength',
    maxLength: 'maxLength',
    expiryDuration: 'expiryDuration',
    maxConsecutiveLetters: 'maxConsecutiveLetters',
    includeNumbers: 'includeNumbers',
    includeSpecialCharacters: 'includeSpecialCharacters',
    lettersInMixedCase: 'lettersInMixedCase',
    excludeCommonUnsafePassword: 'excludeCommonUnsafePassword',
    excludeUserProfileInformation: 'excludeUserProfileInformation',
    oldPasswords: 'oldPasswords',
    passwordHistoryEnabled: 'passwordHistoryEnabled'
};
export const LENGTH_DESCRIPTION = 'Set the minimum and maximum length of user passwords'
export const EXPIRATION_DURATION_DESCRIPTION = 'Determines how long a password can be used before the user must update it. If the password must never expire, enter the value 0.'
export const INCLUSIONS_DESCRIPTION = 'Determine mandatory inclusions for the password'
export const EXCLUSIONS_DESCRIPTION = 'Determine mandatory exclusions for the password'
export const CONSECUTIVE_LETTERS_DESCRIPTION = 'Set the maximum number of times letters can appear next to each other'
export const ERROR_IN_FETCHING_IDENTITY_PROVIDERS = 'There is some problem in fetching Identity Provider, please contact your system administrator.';
export const ENABLE_BY_USER_STORE_MESSAGE = 'This feature is available only to users of the Blue Yonder User Store. To enable it, navigate to the Settings tab or contact your system administrator.';
export const PASSWORD_HISTORY_DESCRIPTION = 'Specifies the number of previous passwords remembered to prevent reuse when setting a new password.';